import { combineReducers } from 'redux';

import * as types from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   [integration: string]: boolean,
 * }} IsLoadingMediariesReducer
 */

/**
 * @typedef {{
 *   isLoading: IsLoadingMediariesReducer,
 * }} MediariesReducer
 */

const initialState = {};

const reset = () => initialState;

/**
 * @param {string[]} integrations
 * @param {boolean} newState
 * @returns {IsLoadingMediariesReducer}
 */
const updateIntegrationsState = (integrations, newState = false) =>
  integrations.reduce((acc, integration) => ({ ...acc, [integration]: newState }), {});

/**
 * @param {IsLoadingMediariesReducer} state
 * @param {import('modules/interventions/types/actions').MediariesExportAction} action
 */
const isLoading = (state, { payload }) => ({
  ...state,
  ...updateIntegrationsState(payload.request.data.integrations, true),
});

/**
 * @param {IsLoadingMediariesReducer} state
 * @param {import('modules/interventions/types/actions').MediariesExportSuccessAction} action
 */
const onSuccess = (state, { payload }) => ({
  ...state,
  ...updateIntegrationsState(payload, false),
});

/**
 * @param {IsLoadingMediariesReducer} state
 * @param {import('modules/interventions/types/actions').MediariesExportFailureAction} action
 */
const onFailure = (state, { payload: { integrations } }) => ({
  ...state,
  ...updateIntegrationsState(integrations, false),
});

export default combineReducers({
  isLoading: createReducer(initialState, {
    [types.MEDIARIES_EXPORT]: isLoading,
    [types.MEDIARIES_EXPORT_SUCCESS]: onSuccess,
    [types.MEDIARIES_EXPORT_FAILURE]: onFailure,
    [LOCATION_CHANGE]: reset,
  }),
});
